import { useSuspenseQuery } from "@apollo/client";
import {
  Button,
  DataTable,
  Dialog,
  DialogContent,
  DialogTrigger,
  PrimaryFullScreenSpinner,
} from "@repo/ui";
import { formatLocalDateTime } from "@repo/utils";
import { createFileRoute } from "@tanstack/react-router";
import type { ColumnDef } from "@tanstack/react-table";
import { Suspense, useState } from "react";
import { AdminPageContainer } from "~/components/layout/AdminPageContainer";
import { AdminPageHeader } from "~/components/layout/AdminPageHeader";
import { graphql } from "~/gql/client";
import type { WaitlistFieldsFragment } from "~/gql/client/graphql";
import { opsHead } from "~/head";

export const Route = createFileRoute("/__auth/waitlist")({
  head: () => opsHead("Waitlist"),
  component: () => (
    <Suspense fallback={<PrimaryFullScreenSpinner />}>
      <View />
    </Suspense>
  ),
});

const columns: ColumnDef<WaitlistFieldsFragment>[] = [
  {
    accessorKey: "createdAt",
    cell: ({ row }) => formatLocalDateTime(row.original.createdAt),
  },
  { accessorKey: "name" },
  { accessorKey: "email" },
  { accessorKey: "organisationName" },
  { accessorKey: "website" },
  { accessorKey: "referralCode" },
];

function View() {
  const { data } = useSuspenseQuery(
    graphql(`
      query GetWaitlistEntries {
        waitlist {
          ...WaitlistFields
        }
      }

      fragment WaitlistFields on WaitlistEntry {
        id
        name
        email
        organisationName
        website
        referralCode
        createdAt
        updatedAt
      }
    `),
  );

  const waitlistEntries = (data?.waitlist ?? []).filter(
    (w) => w.__typename === "WaitlistEntry",
  );

  const [open, onOpenChange] = useState(false);

  return (
    <AdminPageContainer testId="admin-waitlist">
      <AdminPageHeader
        title="Waitlist entries"
        subtitle="These are users who have signed up to the waitlist through https://app.primary.tech/book-a-demo"
      />
      <DataTable
        data={waitlistEntries.sort(
          (a, b) => b.createdAt.getTime() - a.createdAt.getTime(),
        )}
        columns={columns}
      />

      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogTrigger asChild>
          <Button className="w-fit" size="sm">
            Test
          </Button>
        </DialogTrigger>
        <DialogContent className="min-w-[600px] p-16">
          <div> Hello world </div>
        </DialogContent>
      </Dialog>
    </AdminPageContainer>
  );
}
